import React from 'react';
import { connect } from 'react-redux';

import { CardHeader as Header } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

import { _ } from '../../functions/translator.js';
import DescriptionIcon from '@material-ui/icons/Description';
import { getRandomElement, parseDateFromNow } from '../../functions/utils.js';
import { getUserAvatarSrc } from '../../functions/userAvatar.js';

class CardHeader extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            cardUser : '',
            avatarSrc : ''
        };
    }
    
    getUser() {
        let cardUser = ''
        let avatarSrc = '' 
        if (this.props.card) {
            let user = this.props.card.user.id ? this.props.card.user : Object.values(this.props.card.user)[0]
            cardUser =  user.attributes.first_name +' '+ user.attributes.last_name
            if (user.attributes.position) {
                cardUser += ' - ' + user.attributes.position
            }
            avatarSrc = getUserAvatarSrc(user.attributes.first_name, user.attributes.last_name);
            this.setState({ avatarSrc : avatarSrc })
            this.setState({ cardUser : cardUser })
        }
    }

    componentDidMount() {
        this.getUser()
    }

    render() {   

        let url = '/card/show?card_id='
        let customCardId = this.props.cardsGroup.attributes.customcard_id
        if (customCardId) {
            let customcard = this.props.customcards[customCardId.toString()]
            if (customcard.attributes.pdf_path) {
                url = '/card/show/custom?card_id='
            }
        }
        url += this.props.card.id

        let userName = this.state.cardUser
        let avatarSrc = this.state.avatarSrc
        if (window.is_demo) {
            userName = getRandomElement(window.demo_user_names)
            avatarSrc = getUserAvatarSrc(userName.split(' ')[0], userName.split(' ')[1]);
        }
        const revisionText = `${_('Revisión')} N° ${this.props.rev}`;
        const dateText = this.props.card ? parseDateFromNow(this.props.card.attributes.datetime) : '';
        return (
            <div>
                <Grid container justify="space-between">
                    <Header
                        avatar={<Avatar alt={ userName } src={ avatarSrc }/>}
                        title={ userName }
                        subheader={`${revisionText} (${dateText})`}
                        >
                    </Header>
                    { this.props.card && 
                        <a type="button" class="btn btn-outline-danger btn-icon-text float-right" href={url} target="_blank" style={{height: '30px'}} rel="noopener noreferrer"><DescriptionIcon/>PDF</a>
                    }
                </Grid>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        customcards  : state.projectData.customcards
    }
}


export default connect(mapStateToProps)(CardHeader)